import React, { useState } from "react";
import cancelIcon from "../../../assets/images/cancel.png";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";

export default function ScreenshotModal({ screenshots, startIndex, onClose }) {
  const [idx, setIdx] = useState(startIndex);

  // Lock background scroll while modal is open
  useLockBodyScroll(true);

  const handleOutsideClick = (e) => {
    if (e.target.id === "overlay") {
      onClose();
    }
  };

  return (
    <div
      id="overlay"
      onClick={handleOutsideClick}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
    >
      <div className="bg-white rounded-xl p-5 pt-6 max-w-md w-full relative min-h-[400px]">
        {/* Cancel icon */}
        <div className="w-full flex justify-end mb-2">
          <img
            src={cancelIcon}
            alt="Close"
            onClick={onClose}
            className="w-6 h-6 cursor-pointer hover:scale-110 transition"
          />
        </div>

        {/* Image and navigation */}
        <div className="relative flex justify-center mb-2">
          <img
            src={screenshots[idx]}
            alt={`Screenshot ${idx + 1}`}
            className="rounded-lg object-contain w-auto max-h-[50vh] md:max-h-[60vh] lg:max-h-[65vh]"
          />

          <button
            onClick={() => setIdx((i) => Math.max(i - 1, 0))}
            disabled={idx === 0}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow"
          >
            ‹
          </button>
          <button
            onClick={() =>
              setIdx((i) => Math.min(i + 1, screenshots.length - 1))
            }
            disabled={idx === screenshots.length - 1}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow"
          >
            ›
          </button>
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center mt-4 space-x-2">
          {screenshots.map((_, i) => (
            <span
              key={i}
              className={`w-2 h-2 rounded-full ${
                i === idx ? "bg-blue-600" : "bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
